module.exports = __webpack_public_path__ + "img/edit.482c8b64.svg";